import styled, { css } from "styled-components";

interface IConsolePageModalContainerProps {
  isOpen: boolean;
  maxWidth?: string;
}

export const ConsolePageModalContainer = styled.div<IConsolePageModalContainerProps>`
  background: #00000057;
  backdrop-filter: blur(2px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  opacity: 0;
  pointer-events: none;

  &,
  > div.modal-content {
    transition: 0.3s all;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      pointer-events: all;

      > div.modal-content {
        scale: 1;
      }
    `}

  > .modal-content {
    background-color: ${({ theme }) =>
      theme.mode === "dark" ? "#0f0f0f" : "#ffffff"};
    border-radius: 4px;

    scale: 0.95;

    border: 1px solid ${({ theme }) => theme.console.sidebar.borderColor};
    box-shadow: 0px 0px 32px 0px #00000014;

    max-width: ${({ maxWidth }) => maxWidth || "600px"};
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;
